<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> Svn相关
                </el-breadcrumb-item>
                <el-breadcrumb-item>创建用户</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="form-box">
                <el-form ref="form" :model="form" :rules="insertRole" label-width="85px">
                    <el-form-item label="登录名" prop="username">
                        <el-input v-model="form.username"></el-input>
                    </el-form-item>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showloginNameMsg">* 用户名 {{loginNameMsg}} 已占用</div>
                    <div style="margin-left: 85px" class="el-upload__tip">* 登录名不能包含中文与符号</div>

                    
                    <el-form-item label="全名" prop="realUserName" style="margin-top: 20px">
                        <el-input v-model="form.realUserName"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="passwd">
                        <el-input v-model="form.passwd" type="password" show-password auto-complete="new-password" style="width: 82%"></el-input>
                        <el-button @click="getRandomPasswd()" style="float: right; margin-top: 2px">生成密码</el-button>
                    </el-form-item>
                    <div style="margin-left: 85px" class="el-upload__tip">* 密码必须包含 1个数字,1个大写字母,1个小写字母</div>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showPasswdMsg">* 密码不能有顺序 {{passwdMsg}}</div>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showPasswdMsg2">* {{passwdMsg2}}</div>
                    
                    <el-form-item label="确认密码" prop="passwordConfirm" style="margin-top: 20px">
                        <el-input v-model="form.passwordConfirm" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="电邮" prop="email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showEmailMsg">* 电邮地址 {{emailMsg}} 格式不对</div>
                    
                    <el-form-item label="描述" prop="description" style="margin-top: 20px">
                        <el-input v-model="form.description"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="授予的角色">
                        <el-checkbox-group v-model="form.authorities">
                            <el-checkbox v-for="item in init_authorities" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                        <span style="font-size: 9px; margin-left: 25px; color: #e6a23c">访问规则需要同时拥有 “版本库管理员” 和 “用户账户管理员” 才能进行访问</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading="form.loading">表单提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { postPersonnelInfo } from '../../api/svnAPI.js'
export default {
    name: 'svnInsert',
    data() {
        const checkPassword = (rule, value, callback) => {
            if (!value) {
                callback()
            } else if (value !== this.form.passwd) {
                callback(new Error("两次输入的密码不一致"))
            }
            callback()
        }

        const checkEmail = (rule, value, cb) => {
            const regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g
            if (regEmail.test(value)) {
                return cb()
            }
            cb(new Error('请输入正确的电邮地址'))
        }
        const checkUsername = (rule, value, cb) => {
            const regUsername = /[\u4E00-\u9FA5]/g
            if (!regUsername.test(value)) {
                return cb()
            }
            cb(new Error('不能包含中文'))
        }
        return {
            // SVN 服务地址
            serviceUrl: localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl'),

            form: {
                username: '',
                realUserName: '',
                passwd: '',
                passwordConfirm: '',
                email: '',
                description: '',
                authorities: [2],  // 默认选中
                
                // loading加载
                loading: false,

                url: this.serviceUrl,
                sessId: localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
            },
            insertRole: {
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur'},
                    { validator: checkUsername }
                ],
                realUserName: [{ required: true, message: '请输入全名', trigger: 'blur'}],

                passwd: [
                    { required: true, message: '请输入密码', trigger: 'blur'},
                    { min: 8, message: '长度为不能小于8位', trigger: 'blur' },
                ],

                passwordConfirm: [
                    { required: true, message: '请输入确认密码', trigger: 'blur'},
                    { validator: checkPassword }
                ],

                email: [
                    { required: true, message: '请输入电邮', trigger: 'blur'},
                    { validator: checkEmail}
                ],
            },

            // username  登录名错误提示
            showloginNameMsg: false,
            loginNameMsg: '',
            // passwd 非法序列提示
            showPasswdMsg: false,
            passwdMsg: '',
            // passwd 不满足要求
            showPasswdMsg2: false,
            passwdMsg2: '',
            // email  邮箱格式不对
            showEmailMsg: false,
            emailMsg: '',

            init_authorities: [
                {
                    name: 'ROLE_ADMIN - 超级/根管理员（全部权限）',
                    id: 1
                },
                {
                    name: 'ROLE_ADMIN_HOOKS - Repository Hook Scripts Administrator',
                    id: 5
                },
                {
                    name: 'ROLE_ADMIN_REPO - 版本库管理员',
                    id: 4
                },
                {
                    name: 'ROLE_ADMIN_SYSTEM - 系统／服务器管理员',
                    id: 3
                },
                {
                    name: 'ROLE_ADMIN_USERS - 用户帐户管理员',
                    id: 6
                },
                {
                    name: 'ROLE_USER - 访问控制台所需基本用户权利',
                    id: 2
                }
            ],
        };
    },
    mounted() { 
        this.serviceUrl = localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl')
        this.form.sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
    },
    methods: {
        //生成随机密码
        getRandomPasswd(PasLength = 16) {
            let pasArr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v',
            'w','x','y','z','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V',
            'W','X','Y','Z','0','1','2','3','4','5','6','7','8','9'];
            let passwd = ''
            for(let i = 0; i < PasLength; i++) {
                let x = Math.floor(Math.random() * pasArr.length)
                passwd = passwd + pasArr[x]
            }
            
            //密码必须包含 大小写与数字
            if(!passwd.match(/^(\d+[a-zA-Z]+|[a-zA-Z]+\d+)([0-9a-zA-Z]*)$/)) {
                passwd = ''
                this.getRandomPasswd()
            }else {
                this.form.passwd = passwd
                this.form.passwordConfirm = passwd
            }
        },

        onSubmit() {
            //错误信息 隐藏
            this.showLoginNameMsg = false
            this.showPasswdMsg = false
            this.showPasswdMsg2 = false
            this.showEmailMsg = false

            this.$refs.form.validate(valid => {
                if(valid) {
                    // loading等待
                    this.form.loading = true

                    // 参数信息
                    this.form.url = this.serviceUrl
                    let params = JSON.stringify(this.form)
                    //发送请求
                    postPersonnelInfo(params).then(res => {
                        
                        if (res.data.code == 200) {
                            this.form.loading = false
                            this.$message.success('新增成功')
                            this.$router.push('/svnManage')
                        } else if (res.data.code == 777){
                            this.form.loading = false
                            this.$message.warning(res.data.message)
                            this.$message.warning('Svn未登录')
                        } else if (res.data.code == 716) {
                            this.form.loading = false
                            //登录已被占用
                            if (res.data.data.loginNameMsg !== undefined) {
                                this.loginNameMsg = res.data.data.loginNameMsg
                                this.showloginNameMsg = true
                            }
                            //密码非法序列 展示
                            if (res.data.data.passwdMsg !== undefined) {
                                this.passwdMsg = res.data.data.passwdMsg
                                this.showPasswdMsg = '密码不能有顺序'
                            }
                            //密码不满足要求
                            if (res.data.data.passwdMsg2 !== undefined) {
                                this.passwdMsg2 = res.data.data.passwdMsg2
                                this.showPasswdMsg2 = true
                            }
                            //邮箱格式不对
                            if (res.data.data.emailMsg !== undefined) {
                                this.emailMsg = res.data.data.emailMsg
                                this.showEmailMsg = true
                            }
                            //位置参数错误
                            if (res.data.data.errorMsg !== undefined) {
                                this.$message.error(res.data.data.errorMsg)
                            }
                            
                        } else {
                            this.form.loading = false
                            this.$message.error(res.data.message)
                        }
                    }).catch(err =>{
                        this.form.loading = false
                        this.$message.error('权限不足 或 未知错误')
                    })
                }
            })
        }
    }
};
</script>